import Promise from 'promise'

// This is our special type of Error that represents
// when a request got a 401 Unauthorized response
export function UnauthorizedError(message) {
    this.name = 'UnauthorizedError'
    this.message = message
}

// eslint-disable-next-line
UnauthorizedError.prototype = new Error;

// TODO - This should work but isn't
// export class UnauthorizedError extends Error {
//     constructor(message) {
//         super(message);
//         this.name = 'UnauthorizedError';
//         this.message = message;
//     }
// }

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response
    } else if(response.status === 401) {
        var unauthorizedError = new UnauthorizedError(response.statusText)
        unauthorizedError.response = response;
        return Promise.reject(unauthorizedError)
    } else {
        var error = new Error(response.statusText)
        error.response = response
        return Promise.reject(error)
    }
}

function logErrorReason(reason) {
    // log the error reason but keep the rejection
    console.log('Response error reason:', reason)
    return Promise.reject(reason)
}

export async function fetchDataPromise(path, options={}) {
    return await fetch(process.env.REACT_APP_API_URL+ `${path}`, {
        credentials: 'include',
        mode: 'cors',
        ...options,
        headers: {
            Accept: 'application/json',
            ...options.headers,
        },
    })
    .then(checkStatus)
    .catch(logErrorReason)
}

export const fetchData = async (path) => {
    return fetchDataPromise(path)
}
    // //fetch(process.env.REACT_APP_API_ROOT + `${path}`, {
    // fetch('https://' + window.location.host + `${path}`, {
    //     headers: {
    //         Accept: 'application/json'
    //     },
    //     credentials: 'include'
    // })
    // .then(checkStatus)
    // .then(parseJSON)
    // .catch(logErrorReason)


// WEBPACK FOOTER //
// ./src/utils/fetch.js